import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Qualification Service */
const addQualification = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.addQualification}`,
        method: "POST",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Qualification Service */
const getAllQualification = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getAllQualification}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Qualification By Parent Id */
const getAllQualificationsByParentId = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.getAllQualificationsByParentId}`,
        method: "GET",
        params: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};

/* Get Qualification By Parent Id Service */
const updateQualification = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.updateQualification}`,
        method: "PUT",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};


/* Delete Qualification Service */
const deleteQualification = (params) => {
    const { axiosInstance, config } = getAxiosConfig();
    const response = axiosInstance({
        url: `${baseUrls.main}/${apiUrls.admin.deleteQualification}`,
        method: "DELETE",
        data: params,
        headers: config.headers || null,
        mode: "no-cors",
    })
        .then((res) => {
            return setFormatedResponse(res);
        })
        .catch((error) => {
            return getFomatedError(error);
        });
    return response;
};



export default {
    addQualification,
    getAllQualification,
    getAllQualificationsByParentId,
    updateQualification,
    deleteQualification

}